// extracted by mini-css-extract-plugin
export default {"ico":"history-tooltip_ico__JxZZm","container":"history-tooltip_container__xh8Op","tooltip":"history-tooltip_tooltip__nRDPF"};